module.exports = __webpack_public_path__ + "open-sans.3eb14f3838ada50e10f0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/google/open-sans.woff
// module id = 708
// module chunks = 2